import { FallbackCurrencyId, type CurrencyId } from "@/services/currencies/currenciesTypes";
import type { CountryCode } from "@/services/translation";
import { type LanguageId } from "@/services/translation";
import { readonly } from "vue";

const currencyId = ref<CurrencyId>(FallbackCurrencyId);

const languageId = ref<LanguageId | undefined>(undefined);

const countryCode = ref<CountryCode | undefined>(undefined);

const isStartupUserCheckDone = ref(false);

export function useAppStore() {
  const setStartupUserCheckDone = () => {
    isStartupUserCheckDone.value = true;
  };

  const setCurrencyId = (id: CurrencyId) => {
    currencyId.value = id;
  };

  const setCountryCode = (code: CountryCode) => {
    countryCode.value = code;
  };

  const setLanguageId = (id: LanguageId) => {
    languageId.value = id;
  };

  return {
    currencyId: readonly(currencyId),
    languageId: readonly(languageId),
    countryCode: readonly(countryCode),
    isStartupUserCheckDone: readonly(isStartupUserCheckDone),

    setCountryCode,
    setCurrencyId,
    setLanguageId,
    setStartupUserCheckDone,
  };
}
